import { render } from "./App.vue?vue&type=template&id=1b8511a4&scoped=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=1b8511a4&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-1b8511a4"

export default script